// import { ObjectType } from "types"
import { isValidJSON } from "./isValidJSON";


export const StringJSONPRS=({data}:{data:string|ObjectType<any>}):string|ObjectType<any>=>{ // change the Json to String or String to Json 
    


    if( !isValidJSON(data) ){
        const subTemp= data as {
            position:{x:number,y:number,z:number},
            rotation:{x:number,y:number,z:number},
            scale:{x:number,y:number,z:number}
        } 
        if(subTemp){
            
            return JSON.stringify({
                position:[
                    subTemp.position.x,
                    subTemp.position.y,
                    subTemp.position.z
                ].map(i=>(Number(i)+0.001).toFixed(2)),
                rotation:[
                    subTemp.rotation.x,
                    subTemp.rotation.y,
                    subTemp.rotation.z
                ].map(i=>(Number(i)+0.001).toFixed(2)),
                scale:[
                    subTemp.scale.x,
                    subTemp.scale.y,
                    subTemp.scale.z  
                ].map(i=>(Number(i)+0.001).toFixed(2))
                
            });
        }
            

    }else {
        const temp = data as string;
        if(isValidJSON(temp)){
            return JSON.parse(temp) 
        }

    }
   
    
    
    return ""
}